// extracted by mini-css-extract-plugin
export default {"display":"Display_display__CdZ0v"};